import { useCallback, useRef, useState } from 'react';

export const useInfiniteScroll = (limit: number) => {
  const [offset, setOffset] = useState(0);
  const lastScrollPosition = useRef(0);

  const handleScroll = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        const { scrollTop, clientHeight, scrollHeight } = node;
        const currentScrollPosition = scrollTop + clientHeight;

        // User has scrolled to the bottom
        if (
          currentScrollPosition >= scrollHeight &&
          currentScrollPosition !== lastScrollPosition.current
        ) {
          setOffset((prevOffset) => prevOffset + limit);
          lastScrollPosition.current = currentScrollPosition;
        }
      }
    },
    [limit]
  );

  const viewportRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        // Attach the scroll event listener
        node.addEventListener('scroll', () => handleScroll(node));
        // Cleanup the event listener when the ref changes or component unmounts
        return () =>
          node.removeEventListener('scroll', () => handleScroll(node));
      }
    },
    [handleScroll]
  );

  return { viewportRef, offset, setOffset };
};
